import {useRouter} from "next/router";
import {useEffect, useRef, useState} from "react";
import styles from "components/sections/palette/postContent.module.scss";
import {searchRoute} from "common/const";
import classNames from "classnames";
import Nickname from "components/Nickname";
import utilStyles from "styles/utils.module.scss";
import CreatorBadgeIcon from "images/icons/creator_badge.svg";

export const PostContent = (props) => {
    const {item, maxLines, setMaxLines, includeBadge} = props;

    const router = useRouter();
    const measure = props.measure || function () {};

    const onTruncate = props.onTruncate || function () {};

    const textRef = useRef(null);

    const [calculatedNodes, setCalculatedNodes] = useState(null);

    const textToATag = (text, idx) => {
        return (
            <a
                key={idx}
                className={styles.hashTag}
                onClick={e => {
                    router.push({
                        pathname: searchRoute,
                        query: {query: text},
                    });
                    e.stopPropagation();
                }}>
                {text}
            </a>
        )
    };

    useEffect(() => {
        if (!item?.id) {
            return;
        }
        if (textRef.current) {
            let children = textRef.current.childNodes;
            if (children.length < 1) return;

            const range = document.createRange();
            range.selectNodeContents(children[0]);
            const rects = range.getClientRects();
            if (rects.length < 1) return;
            const rect = rects[0];
            const firstLineBottom = rect.bottom;
            // const firstLine
            const totalRight = textRef.current.parentNode.getBoundingClientRect().right;
            let isTruncated = false;
            let cutIndex = -1;

            const safeChildren = [];
            for (const [idx, node] of children.entries()) {
                const range = document.createRange();
                range.selectNodeContents(node);
                const rects = Array.from(range.getClientRects());
                if (
                    rects.filter(rect => {
                        return rect.bottom > firstLineBottom + 30;
                    }).length > 0
                ) {
                    isTruncated = true;
                    break;
                } else {
                    if (node.tagName === 'A') {
                        safeChildren.push(textToATag(node.textContent, idx));
                    } else if (node.nodeType === 8) {
                    } else {
                        safeChildren.push(node.textContent);
                    }
                }

                if (
                    rects.filter (rect => {
                        return (rect.bottom > firstLineBottom + 10 && rect.right > totalRight - 70)
                    }).length > 0 && cutIndex === -1
                ) {
                    cutIndex = idx;
                }
            }

            if (isTruncated && safeChildren[safeChildren.length - 1]) {
                const node = safeChildren[safeChildren.length - 1];
                const range = document.createRange();
                try {
                    range.selectNodeContents(node);
                } catch (e) {}
                const rects = range.getClientRects();
                for (rect of rects) {
                    if (!(rect.bottom > firstLineBottom + 10 && rect.right > totalRight - 70)) {
                        safeChildren.pop();
                    }
                }
            }


            if (typeof(safeChildren[safeChildren.length - 1]) === 'string' && safeChildren[safeChildren.length - 1].includes('\n')) {
                safeChildren.pop();
            }

            if (isTruncated) {
                if (cutIndex !== -1) {
                    safeChildren.splice(cutIndex);
                }

                const onShowMoreClick = (e) => {
                    typeof mixpanel !== 'undefined' && mixpanel.track(
                        'PostCardShowMoreClick',
                        {
                            postId: item.id,
                        }
                    );
                    setMaxLines(5000);
                    e.stopPropagation();
                };

                safeChildren.push(
                    <span key="-1" style={{display: 'inline'}}>... <a onClick={onShowMoreClick} className={classNames(styles.seeMore)}>더보기</a></span>
                )
            }

            setCalculatedNodes(safeChildren);
        }
    }, [item?.id]);

    useEffect(() => {
        measure();
    }, [maxLines]);

    if (maxLines === 2) {
        return (
            <span className={styles.content}>
                <Nickname
                    value={item?.user.nickname} creatorCode={item?.user.code}
                    className={classNames(styles.contentNickname, includeBadge ? utilStyles.verticalMiddle : undefined)}
                />
                {
                    includeBadge &&
                    <CreatorBadgeIcon viewBox="0 0 16 16" width={12} height={12} className={utilStyles.verticalMiddle} style={{marginRight: 4}} />
                }
                <span className={classNames(utilStyles.verticalMiddle, "postText")} style={{display: 'inline'}} ref={textRef}>
                    {
                        calculatedNodes ?
                            calculatedNodes
                            :
                            item?.text.split(/(\s+)/).map((e, idx) => {
                                if (e.startsWith('#')) {
                                    return textToATag(e, idx);
                                }
                                return e;
                            })
                    }
                </span>
            </span>
        );
    } else {
        return (
            <span className={classNames(styles.content, styles.nonTruncate)}>
                <Nickname creatorCode={item?.user.code} value={item?.user.nickname} className={classNames(styles.contentNickname, includeBadge ? utilStyles.verticalMiddle : undefined)} />
                {
                    includeBadge &&
                    <CreatorBadgeIcon viewBox="0 0 16 16" width={12} height={12} className={utilStyles.verticalMiddle} style={{marginRight: 4}} />
                }
                <span className={utilStyles.verticalMiddle} style={{display: 'inline'}}>
                    {item?.text.split(/(\s+)/).map((e, idx) => {
                        if (e.startsWith('#')) {
                            return (
                                <a
                                    key={idx}
                                    className={styles.hashTag}
                                    onClick={e => {
                                        router.push({
                                            pathname: searchRoute,
                                            query: {query: e},
                                        });
                                        e.stopPropagation();
                                    }}>
                                    {e}
                                </a>
                            )
                        }
                        return e;
                    })}
                </span>
            </span>
        );
    }
};
